import {FavoriteButton} from './FavoriteButton';
export default FavoriteButton;
